export default {
  iv:'8764541629098765',
  publicKey:'-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhC7Yq70Vj6ZU2HI4OsCcY5Qvdy2BKGSbE9W4Hw3T1bW4bLwS+45aSxuZxzfq/uCSykezMWk4C/9b0GFroGQpCBb2lidi5X9iGkpdtAAEVxTyEF59fvfH+BSLIOM1Ugtee4S223MeoEQrTcHt2NxsPDNKM/sUJfLJUZXT1A5zelAwzS0TX9SSJTne20yy0FFVYnFHbm+uPaapvRrR1QRMWx9NKgZdjLProaljvl4Lb3lDwADCckVQcEATDZCC2N9OzzTADUsr0nkxQE/Yr6JkYbFyS0kBAK8FKlu+fFE/iN3SqKFcL4vpI5WMicupD0g2GoEFalhIh29AOfRixgvKUQIDAQAB-----END PUBLIC KEY-----',
  v:'1',
}


// WEBPACK FOOTER //
// ./src/assets/js/encryptKey.js